var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevelBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1371 7.41935C16.7012 7.09155 16.1658 7.08927 15.7299 7.41326L10.3715 11.3932C9.93262 11.7195 9.66113 12.3264 9.66113 12.9843V20.1608C9.66113 21.173 10.2925 21.9937 11.0712 21.9937H16.4297C17.2084 21.9937 17.8398 21.173 17.8398 20.1608V9.00508C17.8392 8.35177 17.5712 7.74714 17.1371 7.41935Z",
    fill: "#273E52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54739 14.5461C7.11207 14.2152 6.57611 14.2145 6.1402 14.54L0.710982 18.5731C0.155714 18.9846 -0.116946 19.8311 0.047469 20.6342C0.211299 21.4381 0.770663 21.9971 1.41019 21.9971H6.83999C7.61877 21.9971 8.2501 21.1765 8.2501 20.1642V16.1303C8.25069 15.4785 7.98271 14.8731 7.54739 14.5461Z",
    fill: "#273E52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7973 0.247659C26.362 -0.0808963 25.826 -0.0824173 25.3901 0.242335L19.9609 4.27474C19.5215 4.60102 19.25 5.20869 19.25 5.86656V20.164C19.25 21.1763 19.8813 21.997 20.6601 21.997H26.0893C26.8681 21.997 27.4994 21.1763 27.4994 20.164V1.8334C27.5 1.18009 27.232 0.575454 26.7973 0.247659Z",
    fill: "#273E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelBlue);
export default __webpack_public_path__ + "static/media/level-blue.03b014cb1ec8741ee8cf59d83713ee5a.svg";
export { ForwardRef as ReactComponent };